import { NextResponse } from 'next/server'
import { query, queryOne, uuid } from '@/lib/db'

export async function GET(req: Request) {
  const { searchParams } = new URL(req.url)
  const shopId = searchParams.get('shop_id')
  const search = searchParams.get('search')

  let sql = 'SELECT * FROM clients WHERE shop_id = ?'
  const params: any[] = [shopId]

  if (search) {
    sql += ' AND (name LIKE ? OR phone LIKE ?)'
    params.push(`%${search}%`, `%${search}%`)
  }

  sql += ' ORDER BY name'
  const clients = await query(sql, params)
  return NextResponse.json(clients)
}

export async function POST(req: Request) {
  const { shop_id, name, phone } = await req.json()
  const id = uuid()
  await query(
    'INSERT INTO clients (id, shop_id, name, phone, solde) VALUES (?, ?, ?, ?, 0)',
    [id, shop_id, name, phone || null]
  )
  const client = await queryOne('SELECT * FROM clients WHERE id = ?', [id])
  return NextResponse.json(client)
}
